import statesCities from '@/assets/india-states-cities.json';

export const CITIES_BY_STATE = statesCities as Record<string, string[]>;

// Canonical Indian state/UT names = the keys of the bundled state->city list.
// This is the single source of truth the form, map normalization, and external
// auto-populate sources all coerce toward.
export const INDIAN_STATES = Object.keys(CITIES_BY_STATE).sort();

const CANONICAL_BY_LOWER = new Map(INDIAN_STATES.map((name) => [name.toLowerCase(), name]));

// Spelling/abbreviation variants seen from GST/ARN/import sources, mapped to the
// canonical key. Keys are lowercased.
const STATE_VARIANTS: Record<string, string> = {
  orissa: 'Odisha',
  pondicherry: 'Puducherry',
  'nct of delhi': 'Delhi',
  'jammu & kashmir': 'Jammu and Kashmir',
  'j&k': 'Jammu and Kashmir',
  'andaman & nicobar': 'Andaman and Nicobar Islands',
  'andaman and nicobar': 'Andaman and Nicobar Islands',
  uttaranchal: 'Uttarakhand',
  'dadra & nagar haveli': 'Dadra and Nagar Haveli and Daman and Diu',
  'daman & diu': 'Dadra and Nagar Haveli and Daman and Diu',
};

// Coerce a state string from an external source (GST/ARN/Excel import) to a
// canonical name when recognizable; otherwise return the trimmed input so the
// value is never lost (the dropdown tolerates unknown values).
export const normalizeStateName = (raw: string | null | undefined): string => {
  const trimmed = (raw ?? '').trim();
  if (!trimmed) return '';
  const lower = trimmed.toLowerCase();
  return STATE_VARIANTS[lower] ?? CANONICAL_BY_LOWER.get(lower) ?? trimmed;
};
